import { z } from 'zod';
import { request } from '@/lib/api';

export const SUPPLIERS_KEY = ['suppliers'] as const;

export const supplierSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  contactName: z.string().nullish(),
  phone: z.string().nullish(),
  email: z.string().nullish(),
  taxId: z.string().nullish(),
  notes: z.string().nullish(),
  _count: z.object({ contracts: z.number() }).optional(),
});
export type Supplier = z.infer<typeof supplierSchema>;

export interface SupplierInput {
  name: string;
  contactName?: string;
  phone?: string;
  email?: string;
  taxId?: string;
  notes?: string;
}

export const importPreviewSchema = z.object({
  items: z.array(
    z.object({
      name: z.string(),
      contactName: z.string().nullable(),
      phone: z.string().nullable(),
      email: z.string().nullable(),
      taxId: z.string().nullable(),
      notes: z.string().nullable(),
      existing: z.object({ id: z.string(), name: z.string() }).nullable(),
    }),
  ),
  source: z.enum(['table', 'ai', 'text']),
  warnings: z.array(z.string()),
});
export type SupplierImportPreview = z.infer<typeof importPreviewSchema>;
export type ImportedSupplier = SupplierImportPreview['items'][number];

export const suppliersApi = {
  list: (signal?: AbortSignal) => request('/suppliers', { schema: z.array(supplierSchema), signal }),
  create: (v: SupplierInput) => request('/suppliers', { method: 'POST', body: v, schema: supplierSchema }),
  update: (id: string, v: SupplierInput) => request(`/suppliers/${id}`, { method: 'PATCH', body: v, schema: supplierSchema }),
  remove: (id: string) => request(`/suppliers/${id}`, { method: 'DELETE' }),
  previewImport: (file: File) => {
    const body = new FormData();
    body.append('file', file);
    return request('/suppliers/import/preview', { method: 'POST', body, schema: importPreviewSchema });
  },
  importMany: (items: ImportedSupplier[]) =>
    request('/suppliers/import', {
      method: 'POST',
      // שדות ריקים לא נשלחים (המייל נבדק בשרת).
      body: { items: items.map(({ existing: _, ...i }) => Object.fromEntries(Object.entries(i).filter(([, v]) => v != null && v !== ''))) },
      schema: z.object({ created: z.number(), updated: z.number(), unchanged: z.array(z.string()) }),
    }),
};
